<template>
  <div v-if="targetDate && timeLeft.total > 0" class="countdown-widget">
    <!-- <div class="countdown-header text-center mb-2">
      <i class="fa-solid fa-plane-departure me-1"></i>
      <span class="fw-semibold">Départ</span>
      <span class="ms-1 small">{{ formattedDate }}</span>
    </div> -->
    <div class="d-flex gap-2 gap-md-3 justify-content-center">
      <div v-for="item in items" :key="item.label" class="ring-item text-center">
        <svg viewBox="0 0 80 80" class="ring-svg">
          <circle cx="40" cy="40" r="32" fill="rgba(0,0,0,0.45)" stroke="rgba(255,255,255,0.15)" stroke-width="7"/>
          <circle
            cx="40" cy="40" r="32"
            fill="none"
            :stroke="item.color"
            stroke-width="3"
            stroke-linecap="round"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="getDashOffset(item.value, item.max)"
            transform="rotate(-90 40 40)"
            class="ring-progress"
          />
          <text x="40" y="38" text-anchor="middle" dominant-baseline="middle" class="ring-value">{{ padded(item.value) }}</text>
          <text x="40" y="56" text-anchor="middle" dominant-baseline="middle" class="ring-label">{{ item.label }}</text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'

const props = defineProps<{
  targetDate: Date | null | undefined
}>()

const circumference = 2 * Math.PI * 32

const now = ref(new Date())
let intervalId: ReturnType<typeof setInterval> | null = null

const timeLeft = computed(() => {
  if (!props.targetDate) return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 }
  const total = Math.max(0, props.targetDate.getTime() - now.value.getTime())
  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))
  return { total, days, hours, minutes, seconds }
})

const items = computed(() => [
  { label: 'Jours', value: timeLeft.value.days, max: 365, color: '#f59e0b' },
  { label: 'Heures', value: timeLeft.value.hours, max: 23, color: '#38bdf8' },
  { label: 'Min', value: timeLeft.value.minutes, max: 59, color: '#4ade80' },
  { label: 'Sec', value: timeLeft.value.seconds, max: 59, color: '#a78bfa' },
])

function padded(value: number): string {
  return String(value).padStart(2, '0')
}

function getDashOffset(value: number, max: number): number {
  const ratio = Math.min(1, Math.max(0, value / max))
  return circumference * (1 - ratio)
}

onMounted(() => {
  intervalId = setInterval(() => {
    now.value = new Date()
  }, 1000)
})

onUnmounted(() => {
  if (intervalId !== null) {
    clearInterval(intervalId)
    intervalId = null
  }
})
</script>

<style scoped>
.countdown-widget {
  background: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  padding: 5px;
  color: #fff;
  display: block;
  width: 100%;
}

/* .countdown-header {
  font-size: 0.8rem;
  letter-spacing: 0.03em;
  opacity: 0.92;
} */

.countdown-widget .ring-value {
  font-size: 18px;
  font-weight: 700;
  fill: #fff;
  font-family: inherit;
}

.countdown-widget .ring-label {
  font-size: 10px;
  fill: rgba(255, 255, 255, 0.7);
  font-family: inherit;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.countdown-widget .ring-item {
  flex: 1;
  min-width: 0;
}

.countdown-widget .ring-svg {
  display: block;
  width: 100%;
  height: auto;
}

.countdown-widget .ring-progress {
  transition: stroke-dashoffset 0.5s ease;
}
</style>
